import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const SMS = () => {
  const stats = [
    { label: 'Sent', value: '24,500', change: '+3,200', changeType: 'positive' },
    { label: 'Delivered', value: '98.2%', change: '+0.3%', changeType: 'positive' },
    { label: 'Click Rate', value: '12.4%', change: '+1.8%', changeType: 'positive' },
    { label: 'Opt-outs', value: '0.8%', change: '-0.1%', changeType: 'positive' },
  ];

  const campaigns = [
    { name: 'Flash Sale Alert', sent: '8,500', delivery: '99.1%', status: 'Sent' },
    { name: 'Order Confirmation', sent: '12,000', delivery: '98.8%', status: 'Active' },
    { name: 'Appointment Reminder', sent: '4,000', delivery: '97.5%', status: 'Active' },
    { name: 'Promo Code Drop', sent: '0', delivery: '-', status: 'Scheduled' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">SMS Marketing</h1>
        <p className="lm-page-subtitle">Manage SMS campaigns and automation</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">SMS Campaigns</h3>
          <Button variant="primary" size="sm" icon="message-square">New Campaign</Button>
        </div>
        <div className="lm-grid">
          {campaigns.map((campaign, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{campaign.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: campaign.status === 'Sent' ? 'var(--success-soft)' :
                             campaign.status === 'Active' ? 'var(--primary-soft)' : 'var(--warning-soft)',
                  color: campaign.status === 'Sent' ? 'var(--success)' :
                         campaign.status === 'Active' ? 'var(--primary)' : 'var(--warning)'
                }}>{campaign.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>Sent: {campaign.sent} • Delivery: {campaign.delivery}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SMS;
